<template>
    <div class="goodsFormContent">
         <!-- 面包屑 -->
         <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: $route.query.type == '1' ? `/goods/detail?id=${$route.query.id}` : `/service/detail?id=${$route.query.id}`  }">{{ $route.query.type == '1' ? '开发详情' : '服务详情' }}</el-breadcrumb-item>
                <el-breadcrumb-item>订单支付</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 表单 -->
        <div v-if="formData.info">
            <div class="formBox" v-if="payType">
                <div class="formH">订单支付</div>
                <div class="formData column">
                    <div class="formTrBox align">
                        <div class="formTr" style="width: 474px;">应用类别</div>
                        <div class="formTr">购买详情</div>
                        <div class="formTr">订单编号</div>
                        <div class="formTr">单价</div>
                    </div>
                    <div class="formTdBox align">
                        <div class="formTd align" style="width: 474px;">
                            <el-image :src="formData.info.img" fit="cover" class="goodsImg"></el-image>
                            <div class="goodsTitle">{{ formData.info.name }}</div>
                        </div>
                        <div class="formTd">数量: {{ formData.info.num }}</div>
                        <div class="formTd">{{ formData.info.order_num }}</div>
                        <div class="formTd">￥{{ formData.info.price }}</div>
                    </div>
                    <div class="totalBox align">
                        <div class="totalTitle">合计总金额：</div>
                        <div class="totalIcon">￥</div>
                        <div class="totalMoney">{{ formData.total_price }}</div>
                    </div>
                    <el-image :src="formData.code" fit="cover" class="paymentCode"></el-image>
                    <div class="paymentTips">打开手机微信扫一扫付款</div>
                </div>
            </div>
            <!-- 支付成功 -->
            <div class="sucBox column" v-else>
                <div class="align">
                    <el-image :src="require('@/assets/icon/suc.png')" fit="cover" class="sucIcon"></el-image>
                    <div class="sucStatus">支付成功</div>
                </div>
                <div class="sucTipsBox">
                    <div class="sucPrice"><span class="sucPriceIcon">￥</span>{{ payData.total_price }}</div>
                    <div class="sucDetail flex">
                        <div class="sdTitle">订单编号:</div>
                        <div class="sdText">{{ payData.order_num }}</div>
                    </div>
                    <div class="sucDetail flex">
                        <div class="sdTitle">下单时间:</div>
                        <div class="sdText">{{ payData.create_time }}</div>
                    </div>
                    <div class="sucDetail flex">
                        <div class="sdTitle">支付方式:</div>
                        <div class="sdText">扫码支付</div>
                    </div>
                </div>
                <div class="sucBtnBox center">
                    <div class="sucBtnLook">查看订单</div>
                    <div class="sucBtnIndex" @click="sucBtnIndexTap">返回首页</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                userDetail: 0,
                payType: true,
                payTime: '',
                formData: {},
                payData: {}
            }
        },
        beforeDestroy(){
            clearInterval(this.payTime)
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            if(!this.userDetail){
                this.$router.push({ path:'/login/login' })
            }else{
                this.getFormDetail()
            }
        },
        methods: {
            // 获取订单详情
            getFormDetail(){
                let url = this.$route.query.type == '1' ? 'index/kaifa/pay' : 'index/fuwu/pay'
                this.request.get(url,{
                    params:{
                        id: this.$route.query.id,
                        userid: this.userDetail,
                        num: this.$route.query.num
                    }
                })
                .then(res=>{
                    console.log(res.data)
                    this.formData = res.data
                    this.getPayType()
                })
            },
            // 获取支付结果
            getPayType(){
                this.payTime = window.setInterval(() => {
                    this.request.get("index/fuwu/getorderstatus",{
                        params:{
                            order_num: this.formData.info.order_num
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            clearInterval(this.payTime)
                            this.$message({
                                message: '支付成功',
                                type: 'success'
                            });
                            this.payData = res.data
                            this.payType = false
                        }
                    })
                    .catch(err=>{
                        clearInterval(this.payTime)
                    })
                }, 2000);
            },
            // 返回首页
            sucBtnIndexTap(){
                this.$router.replace({ name: 'index' });
            }
        }
    }
</script>
<style lang="less" scoped>
    .goodsFormContent{
        width: 100vw;
        background: #F7F8FA;
        padding-bottom: 60px;
        .formBox{
            width: 1168px;
            padding: 32px;
            border-radius: 8px;
            background: #fff;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            .formH{
                font: 20px/26px "Microsoft YaHei";
            }
            .formData{
                width: 1168px;
                border-top: 1px solid #F5F5F5;
                margin-top: 20px;
                padding-top: 20px;
                .formTrBox{
                    width: 1168px;
                    .formTr{
                        padding: 0 24px;
                        width: 167px;
                        font: 14px/18px "Microsoft YaHei";
                        color: #73727A;
                    }
                }
                .formTdBox{
                    width: 1168px;
                    padding: 24px 0 32px 0;
                    background: #FAFAFC;
                    margin-top: 12px;
                    
                    .formTd{
                        padding: 0 24px;
                        width: 167px;
                        font: 14px/18px "Microsoft YaHei";
                        .goodsImg{
                            width: 90px;
                            height: 55px;
                            border-radius: 3px;
                        }
                        .goodsTitle{
                            width: 360px;
                            padding: 0 12px;
                            font: 16px/20px "Microsoft YaHei";
                            -webkit-line-clamp: 2;
                            display: -webkit-box;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
                .totalBox{
                    margin-top: 52px;
                    .totalTitle{
                        font: bold 16px/32px "Microsoft YaHei";
                    }
                    .totalIcon{
                        font: 18px/32px "Microsoft YaHei";
                        color: #FF2E2E;
                    }
                    .totalMoney{
                        font: bold 24px/32px "Microsoft YaHei";
                        color: #FF2E2E;
                    }
                }
                .paymentCode{
                    width: 186px;
                    height: 186px;
                    margin-top: 16px;
                }
                .paymentTips{
                    font: 16px/18px "Microsoft YaHei";
                    color: #73727A;
                    margin-top: 12px;
                    padding-bottom: 110px;
                }
            }
        }
        .sucBox{
            width: 1232px;
            padding: 56px 0;
            background: #fff;
            border-radius: 8px;
            margin: 0 auto;
            .sucIcon{
                width: 68px;
                height: 68px;
            }
            .sucStatus{
                font: 28px/68px "Microsoft YaHei";
                color: #52C41A;
                padding-left: 16px;
            }
            .sucTipsBox{
                width: 602px;
                padding: 30px 74px;
                background: #FAFAFC;
                margin-top: 42px;
                .sucPrice{
                    font: 28px/38px "Microsoft YaHei";
                    color: #161825;
                    text-align: center;
                    padding-bottom: 26px;
                    margin-bottom: 22px;
                    border-bottom: 1px solid rgba(0,0,0,0.06);
                    .sucPriceIcon{
                        font: 18px/38px "Microsoft YaHei";
                    }
                }
                .sucDetail{
                    padding-bottom: 16px;
                    font: 14px/18px "Microsoft YaHei";
                    .sdTitle{
                        color: #73727A;
                        padding-right: 24px;
                    }
                    .sdText{
                        color: #161825;
                    }
                }
            }
            .sucBtnBox{
                padding: 40px 0;
                .sucBtnLook{
                    width: 126px;
                    height: 38px;
                    border: 1px solid #E0DFE5;
                    border-radius: 4px;
                    font: 16px/38px "Microsoft YaHei";
                    color: #73727A;
                    text-align: center;
                    cursor: pointer;
                }
                .sucBtnIndex{
                    width: 128px;
                    height: 40px;
                    background: #0F59FE;
                    border-radius: 4px;
                    font: 16px/40px "Microsoft YaHei";
                    color: #fff;
                    text-align: center;
                    margin-left: 32px;
                    cursor: pointer;
                }
            }
        }
    }
</style>